module.exports = __webpack_public_path__ + "img/app-store.83a9c18c.png";